var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CriterionSelectorDialog", {
        attrs: { viewModel: _vm.criterionSelectorDialog },
        on: { "confirm-selection": _vm.changeCriterion },
      }),
      _vm._v(" "),
      _vm.criterionEditorOpened === true
        ? _c("div", { staticClass: "modal-mask" }, [
            _c("div", { staticClass: "modal-wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "modal-dialog modal-lg modal-dialog-scrollable",
                  staticStyle: { "min-height": "600px" },
                },
                [
                  _vm.editedCriterion
                    ? _c("div", { staticClass: "modal-content" }, [
                        _c("div", { staticClass: "modal-header" }, [
                          _c("h5", { staticClass: "modal-title" }, [
                            _vm._v(
                              "Criterion: " + _vm._s(_vm.editedCriterion.Name)
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "close",
                              attrs: { type: "button" },
                              on: { click: _vm.closeCriterionEditor },
                            },
                            [_vm._v("×")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "modal-body" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Linked attribute:")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.editedCriterion.attributeNameOrNone,
                                    expression:
                                      "editedCriterion.attributeNameOrNone",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "text", readonly: "" },
                                domProps: {
                                  value:
                                    _vm.editedCriterion.attributeNameOrNone,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.editedCriterion,
                                      "attributeNameOrNone",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group-append" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-secondary dropdown-toggle",
                                    attrs: {
                                      type: "button",
                                      "data-toggle": "dropdown",
                                    },
                                  },
                                  [_vm._v("Choose")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-menu dropdown-menu-right",
                                    staticStyle: {
                                      "background-color": "#F5F5F5",
                                      width: "70%",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "px-2 py-1" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-secondary btn-sm",
                                          on: {
                                            click: function ($event) {
                                              return _vm.showAttributeCreator()
                                            },
                                          },
                                        },
                                        [_vm._v("Create new attribute")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-secondary btn-sm",
                                          attrs: {
                                            disabled:
                                              !_vm.editedCriterion.AttributeId,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.editedCriterion.unlink()
                                            },
                                          },
                                        },
                                        [_vm._v("Unlink attribute")]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "dropdown-divider",
                                    }),
                                    _vm._v(" "),
                                    _c("form", { staticClass: "px-3 py-1" }, [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.SearchAttributePhrase,
                                              expression:
                                                "SearchAttributePhrase",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            placeholder: "search",
                                          },
                                          domProps: {
                                            value: _vm.SearchAttributePhrase,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.SearchAttributePhrase =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "max-height": "200px",
                                          "overflow-y": "auto",
                                          "overflow-x": "hidden",
                                        },
                                      },
                                      _vm._l(
                                        _vm.AttributesSections,
                                        function (s) {
                                          return _c(
                                            "div",
                                            [
                                              s.Section
                                                ? _c(
                                                    "h6",
                                                    {
                                                      staticClass:
                                                        "dropdown-header",
                                                    },
                                                    [_vm._v(_vm._s(s.Section))]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm._l(
                                                s.Attributes,
                                                function (attr) {
                                                  return _c(
                                                    "a",
                                                    {
                                                      key: attr.Id,
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.editedCriterion.link(
                                                            attr.Id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(attr.Name))]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "dropdown-divider",
                                              }),
                                            ],
                                            2
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [
                              _vm.editedCriterion.defaultMax == null
                                ? _c("span", { staticClass: "text-danger" }, [
                                    _vm._v("*"),
                                  ])
                                : _vm._e(),
                              _vm._v("Normalization cap:"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.editedCriterion.MaxValue,
                                  expression: "editedCriterion.MaxValue",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "number",
                                placeholder: _vm.editedCriterion.defaultMax,
                              },
                              domProps: { value: _vm.editedCriterion.MaxValue },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.editedCriterion,
                                    "MaxValue",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "form-text text-muted" }, [
                              _vm._v(
                                "\n                                Criteria must have a maximum value, beyond which no extra value is given in calculating normalized score.\n                                Scores are calculated as a ratio of this Normalization cap. It is usually defined as the highest value in a scale.\n                            "
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "modal-footer" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "button" },
                              on: {
                                click:
                                  _vm.handleUpdateCriterionMeasurementCommand,
                              },
                            },
                            [_vm._v("Confirm")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { type: "button" },
                              on: { click: _vm.closeCriterionEditor },
                            },
                            [_vm._v("Cancel")]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("AttributeEditorDialog", {
        attrs: { viewModel: _vm.attributeEditorDialog },
        on: {
          "numeric-attribute-created": _vm.numericAttributeCreated,
          "numeric-attribute-updated": _vm.numericAttributeUpdated,
        },
      }),
      _vm._v(" "),
      _c("PortfolioOrDecisionNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          !_vm.Initialized
            ? _c("h3", [
                _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                _vm._v(" Loading... "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.Initialized
            ? _c(
                "div",
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("h3", [_vm._v("Goal: " + _vm._s(_vm.rm.GoalName))]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("GoalNavigation", {
                    attrs: {
                      WorkspaceId: _vm.workspaceId,
                      ProjectId: _vm.projectId,
                      EvalModelId: _vm.evalModelId,
                      ActivePage: "measurement",
                      ScoringEnabled: _vm.rm.ScoringEnabled,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "nav",
                    {
                      staticClass:
                        "navbar navbar-light navbar-expand-md bg-light",
                      attrs: { role: "navigation" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "btn-group mr-auto",
                          attrs: { role: "group" },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { type: "button", title: "Expand all" },
                              on: { click: _vm.expandAll },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-expand",
                                attrs: { "aria-hidden": "true" },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { type: "button", title: "Collapse all" },
                              on: { click: _vm.collapseAll },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-compress",
                                attrs: { "aria-hidden": "true" },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "navbar-text" }, [
                        _vm._v("Filter by: "),
                        _c(
                          "a",
                          {
                            staticClass: "text-primary",
                            on: { click: _vm.showCriterionSelector },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.FilterByCriterion?.Name ?? "All criteria"
                              )
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "form",
                        {
                          staticClass: "form-inline my-2 my-lg-0 ml-2",
                          attrs: { role: "search" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "input-group input-group-sm" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.SearchPhrase,
                                    expression: "SearchPhrase",
                                  },
                                ],
                                staticClass: "form-control form-control-sm",
                                attrs: {
                                  type: "search",
                                  placeholder: "Search",
                                },
                                domProps: { value: _vm.SearchPhrase },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.SearchPhrase = $event.target.value
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm._m(1),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("table", { staticClass: "table table-hover" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.BottomCriteriaView, function (c) {
                        return _c("tr", { key: c.Id }, [
                          _c("td", [
                            _c(
                              "button",
                              {
                                staticClass: "btn",
                                class: {
                                  "btn-danger": c.IsValid === false,
                                  "btn-success": c.IsValid === true,
                                },
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showCriterionEditor(c.Id)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa",
                                  class: {
                                    "fa-unlink": c.Attribute == null,
                                    "fa-link": c.Attribute != null,
                                  },
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "h5",
                              {
                                staticClass: "pointer",
                                on: {
                                  click: function ($event) {
                                    c.Expanded = !c.Expanded
                                  },
                                },
                              },
                              [
                                _c("span", [_vm._v(_vm._s(c.Criterion.Name))]),
                                _c("br"),
                                _vm._v(" "),
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(_vm._s(c.Criterion.Path)),
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _c("small", [
                                  _vm._v(
                                    "Normalization cap: " +
                                      _vm._s(
                                        c.Criterion.MaxValue?.toString() ??
                                          "Not set"
                                      )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            c.Expanded
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(_vm._s(c.Criterion.Description)),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            c.Attribute != null
                              ? _c("div", [
                                  _c(
                                    "h5",
                                    {
                                      staticClass: "pointer",
                                      on: {
                                        click: function ($event) {
                                          c.Expanded = !c.Expanded
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(c.Attribute.Name))]
                                  ),
                                  _vm._v(" "),
                                  c.Expanded
                                    ? _c("div", { staticClass: "mt-3" }, [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(c.Attribute.Description)
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        c.Attribute.IsList === true
                                          ? _c(
                                              "div",
                                              _vm._l(
                                                c.Attribute.DefinedValues,
                                                function (dv) {
                                                  return _c(
                                                    "p",
                                                    { key: dv.Name },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(dv.Value) +
                                                            " - " +
                                                            _vm._s(dv.Name)
                                                        ),
                                                      ]),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(dv.Description)
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-sm btn-primary",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showAttributeEditor(
                                                  c.Attribute
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Edit attribute")]
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(3),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      {
        staticClass: "btn btn-outline-secondary float-right",
        attrs: {
          href: "https://www.transparentchoice.com/user-guide/build-criteria",
          title: "User guide: Build criteria",
          target: "_blank",
        },
      },
      [_c("i", { staticClass: "fa fa-info", attrs: { "aria-hidden": "true" } })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", {
          staticClass: "fa-solid fa-magnifying-glass",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { width: "60px" } }),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "50%" } }, [_vm._v("Criterion")]),
        _vm._v(" "),
        _c("th", [_vm._v("Linked attribute")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "alert alert-danger" }, [
      _c("p", [
        _vm._v(
          "\n                    NEGATIVE numbers will be rounded to zero in any calculations.\n                    Remember, you could use calculated attributes to transform your values so they are all positive.\n                "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }